export default __webpack_public_path__ + "static/media/opensans-light-webfont.6c42af05.woff2";